import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AutoTranslatePipe } from 'app/shared/pipes/translate.pipe';

@Component({
    selector: 'app-record-id-badge',
    standalone: true,
    imports: [CommonModule, AutoTranslatePipe],
    template: `
        <span
            *ngIf="value !== null && value !== undefined"
            class="inline-flex items-center rounded-full bg-gray-100 dark:bg-gray-700 px-2.5 py-1 text-sm font-medium text-secondary select-text"
            title="{{ 'ID do registro' | autoTranslate }}"
        >
            #{{ value }}
        </span>
    `,
})
export class RecordIdBadgeComponent {
    @Input() value: string | number | null | undefined;
}
